export enum BuildCost {
  Average = "Domains.Appraisals.Appraisal.BuildCost.Average",
  Check_Average = "Domains.Appraisals.Appraisal.BuildCost.CheckAverage",
  Cost_Average = "Domains.Appraisals.Appraisal.BuildCost.CostAverage",
  Info_Tooltip = "Domains.Appraisals.Appraisal.BuildCost.InfoTooltip",
  Input_Error = "Domains.Appraisals.Appraisal.BuildCost.InputError",
  Input_Error_Partial = "Domains.Appraisals.Appraisal.BuildCost.InputErrorPartial",
  Min_GIA = "Domains.Appraisals.Appraisal.BuildCost.MinGIA"
}
